export const validEmailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;